import React, { useContext } from "react";
import PropTypes from "prop-types";
import { CSCContext } from "../CSCContext";

function PageControls(props) {
	const prevStyle = props.previous ? {} : {visibility: 'hidden'};
	const nextStyle = props.next ? {} : {visibility: 'hidden'};

	return (
		<div className="page-controls">
			<button 
				className="page-prev"
				style={prevStyle}
				onClick={useContext(CSCContext).prevPage}>Previous Page
			</button>
			<button 
				className="page-next"
				style={nextStyle}
				onClick={useContext(CSCContext).nextPage}>Next Page
				</button>
		</div>
	);
};

PageControls.propTypes = {
	previous: PropTypes.bool,
	next: PropTypes.bool,
}

PageControls.defaultProps = {
	previous: true,
	next: true,
}

export default PageControls;